import {connectDynamic, DynamicComponent} from 'go/components/dynamic/dynamicComponent';
import {Loader, Segment, Divider} from 'semantic-ui-react';
import React from 'react';
import _ from 'lodash';
import {Alert} from 'componentLibrary';

export const calculateSamGovValidity = (samgov) => {
  if (!samgov || (samgov && samgov.loading)) {
    return {};
  }
  let isValid =
    samgov.bank.messageType !== 'failure' &&
    samgov.organization.messageType !== 'failure' &&
    samgov.samgov.messageType !== 'failure';

  return {
    validated: isValid,
  };
};

export class SamGovReviewPanel extends DynamicComponent {
  constructor(props) {
    super(props);
    this.state = {
      [this.props.dataPath]: {
        validated: {},
      },
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const samgov = _.get(nextProps, 'dynamicComponent.context.samgov');
    prevState[nextProps.dataPath] = calculateSamGovValidity(samgov);
    return prevState;
  }

  renderMessages(samgov) {
    const messages = [];
    if (samgov.bank.messageType === 'failure') {
      messages.push(
        <Alert
          id={'bank_failure_message'}
          key={'bank_failure_message'}
          type={'error'}
          content={samgov.bank.message[0]}
        />
      );
    }
    if (samgov.organization.messageType === 'failure') {
      messages.push(
        <Alert
          id={'organization_failure_message'}
          key={'organization_failure_message'}
          type={'error'}
          content={samgov.organization.message[0]}
        />
      );
    }
    if (samgov.samgov.messageType === 'failure') {
      messages.push(
        <Alert
          id={'samgov_failure_message'}
          key={'samgov_failure_message'}
          type={'error'}
          content={samgov.samgov.message[0]}
        />
      );
    }
    if (_.isEmpty(messages)) {
      messages.push(
        <Alert
          id={'samgov_success_message'}
          key={'samgov_success_message'}
          type={'success'}
          content={samgov.samgov.message[0]}
        />
      );
    }
    return messages;
  }

  renderOrganizationAddress(samgov) {
    return (
      <React.Fragment>
        Recipient Organization: <br />
        <b>
          {samgov.legalBusinessName}
          <br />
          {samgov.addressLineOne}
          <br />
          {samgov.addressLineTwo ? samgov.addressLineTwo : ''}
          {samgov.addressLineTwo ? <br /> : ''}
          {samgov.city}, {samgov.state} {samgov.zip}
        </b>
      </React.Fragment>
    );
  }

  renderDunsExpiration(samgov) {
    return (
      <p>
        DUNS Expiration
        <br />
        <b>{samgov['dunsExpiration']}</b>
      </p>
    );
  }

  render() {
    const samgov = _.get(this.props, 'dynamicComponent.context.samgov');
    const {data, dataPath} = this.props;

    if (!_.isEqual(this.state[dataPath], data)) {
      this.save();
    }
    if (samgov && !samgov.loading) {
      const registrationStatus = samgov.samgov['samRegistrationStatus'];
      const registrationStatusText = registrationStatus
        ? registrationStatus
        : 'Retrieving registration status.';
      return (
        <React.Fragment>
          {this.renderMessages(samgov)}
          {this.renderOrganizationAddress(samgov)}
          <Divider />
          <p>
            SAM.gov Registration Status
            <br />
            <b>{registrationStatusText}</b>
          </p>
          <Divider />
          {this.renderDunsExpiration(samgov.samgov)}
        </React.Fragment>
      );
    } else {
      return (
        <Segment vertical padded>
          <Loader active>Loading...</Loader>
        </Segment>
      );
    }
  }
}

export default connectDynamic(SamGovReviewPanel);
